import React from 'react';
import {
	Container,
	GrayBox,
	Header,
	Separator,
	Badge,
	FactorContainer,
	LabelContainer,
	HeaderContainer,
	IconContainer,
	FileContainer,
	DescriptionContainer,
} from './RiskFactors.styles';
import { Paragraph, Skeleton, Spinner, tokens } from '@welbe/web-design-system';
import { FiEdit } from 'react-icons/fi';
import {
	SummaryJobProfileType,
	SummaryJobRiskFactors,
	SymmaryJobRisks,
} from 'Views/JobProfile/pages/SummaryRisk/SummaryRisk.types';
import { ExpositionLevelBadgeEnum } from 'Views/JobProfile/pages/FormRisk/components/ExpositionLevel/ExpositionLevel.const';
import { examResultOptions } from 'Views/JobProfile/pages/FormRisk/components/Result/Result';
import { ReactComponent as ListIcon } from 'App/assets/img/list.svg';
import { ReactComponent as BiggerListIcon } from 'App/assets/img/bigger-list.svg';
import { ReactComponent as File } from 'App/assets/img/file-text.svg';
import { JobProfileType } from 'Views/JobProfile/JobProfile.enums';
import { useRiskFactors } from './RiskFactors.hooks';

import physics from '../../assets/physics.png';
import chemical from '../../assets/chemical.png';
import biological from '../../assets/biological.png';
import ergonomic from '../../assets/ergonomic.png';
import psychosocial from '../../assets/psychosocial.png';

type RiskFactorsType = {
	isLoading: boolean;
	summaryJobProfile: SummaryJobProfileType;
	handleEditRisk: (riskid: string) => void;
	handleOpenModalFactor: (
		risk: SymmaryJobRisks,
		factor: SummaryJobRiskFactors,
	) => void;
	handleCloseModalFactor: () => void;
};

export enum listKindEnum {
	list = 'LIST',
	biggerList = 'BIGGET_LIST',
}

const assets: any = {
	fisicos: physics,
	quimicos: chemical,
	biologicos: biological,
	ergonomicos: ergonomic,
	psicosociales: psychosocial,
};

const removeSpecialCharacters = (text: string) => {
	return text
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.replace(/[^a-zA-Z0-9]/g, '')
		.toLowerCase();
};

const getAsset = (name: string) => {
	if (!name) return null;
	const assetFormatted = removeSpecialCharacters(name);

	return assets[assetFormatted];
};

export const RiskFactors = ({
	isLoading,
	summaryJobProfile,
	handleEditRisk,
	handleOpenModalFactor,
}: RiskFactorsType) => {
	const { listKind, loadingFile, handleOpenFile, handleListKind } =
		useRiskFactors();

	const renderBadgeFactor = (factor: SummaryJobRiskFactors) => {
		if (factor.exposureLevel) {
			const expositionLevelEnum = ExpositionLevelBadgeEnum.find((level) => {
				if (level.id === factor.exposureLevel) return level.value;
			});

			return (
				<LabelContainer>
					<Paragraph>{expositionLevelEnum?.value}</Paragraph>
					<Badge
						color={expositionLevelEnum?.color || tokens.color_gray_light}
					/>
				</LabelContainer>
			);
		}
		if (factor.examResult) {
			const examResultEnum = examResultOptions.find((option) => {
				if (option.id === factor.examResult) return option.value;
			});

			return (
				<LabelContainer>
					<Paragraph>{examResultEnum?.value}</Paragraph>
					<Badge color={examResultEnum?.color || tokens.color_gray_light} />
				</LabelContainer>
			);
		}
		return null;
	};

	return (
		<>
			<HeaderContainer>
				<Paragraph
					fontWeight="600"
					padding="0 0 20px 0"
					color={tokens.color_primary}
				>
					Analisis de riesgo
				</Paragraph>
				<IconContainer listKind={listKind}>
					<ListIcon onClick={() => handleListKind(listKindEnum.list)} />
					<BiggerListIcon
						onClick={() => handleListKind(listKindEnum.biggerList)}
					/>
				</IconContainer>
			</HeaderContainer>
			<Container isLoading={isLoading}>
				{isLoading ? (
					<>
						<Skeleton height="80px" />
						<Skeleton height="80px" />
						<Skeleton height="80px" />
						<Skeleton height="80px" />
					</>
				) : (
					<>
						{summaryJobProfile.jobRisks.map((risk) => {
							return (
								<GrayBox key={risk.id} listKind={listKind}>
									<Header>
										<img src={getAsset(risk.name)} />
										<div>
											<Paragraph fontWeight="600">Riesgos</Paragraph>
											<Paragraph>{risk.name}</Paragraph>
										</div>
										<FiEdit
											size={20}
											color={tokens.color_primary}
											onClick={() => handleEditRisk(risk.id)}
										/>
									</Header>

									{listKind === listKindEnum.biggerList && (
										<>
											<Separator />
											<FactorContainer>
												{risk.jobRiskFactors.length > 0 ? (
													risk.jobRiskFactors.map((factor) => (
														<DescriptionContainer key={factor.id}>
															{summaryJobProfile.type ===
																JobProfileType.EXPOSITION_AREA && (
																<FileContainer hasFile={!!factor.examFileName}>
																	{risk.optionType?.includes(
																		'expositionLevel',
																	) && (
																		<>
																			{loadingFile ? (
																				<div>
																					<Spinner />
																				</div>
																			) : (
																				<File
																					width={'20px'}
																					onClick={() =>
																						factor.examFileName &&
																						handleOpenFile(factor)
																					}
																				/>
																			)}
																		</>
																	)}
																</FileContainer>
															)}
															<Paragraph
																cursor="pointer"
																textDecoration="underline"
																onClick={() =>
																	handleOpenModalFactor(risk, factor)
																}
															>
																{factor.name}
															</Paragraph>
															{renderBadgeFactor(factor)}
														</DescriptionContainer>
													))
												) : (
													<Paragraph padding="0 0 10px 0">
														Sin factores de riesgo definidos
													</Paragraph>
												)}
											</FactorContainer>
										</>
									)}
								</GrayBox>
							);
						})}
					</>
				)}
			</Container>
		</>
	);
};
